var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 71,
    viewBox: "0 0 1440 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1380.23 71C1200.38 71 1093.8 46.5464 1092.67 46.2647C879.565 -3.11201 748.929 6.30458 568.167 19.3563C520.225 22.8171 470.599 26.3986 414.015 29.4034C137.459 44.105 1.36458 1.34141 0 0.898752L3.36597 0C4.68507 0.429246 139.324 42.6429 413.15 28.0888C469.644 25.0841 519.133 21.516 567.03 18.0552C749.065 4.92294 880.566 -4.56071 1095.44 45.2184C1096.76 45.5269 1226.08 75.1717 1440.55 68.7464L1441 70.0744C1419.94 70.7183 1399.65 71 1380.23 71Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLine);
export default __webpack_public_path__ + "static/media/auth-line.2b5d7b4f4b037bba3bcbeba38e49e6c1.svg";
export { ForwardRef as ReactComponent };